export interface Tenant {
    id?: string;
    legalName?: string;
    tradeName?: string;
    cnpj?: string;
    cnpjNormalized?: string;
    institutionalEmail?: string;
    institutionalPhone?: string;
    language?: TenantLanguage;
    plan?: PlanReference;
    subdomain?: string;
    status?: TenantStatus;
    activeUserCount?: number;
    userStatusSyncPending?: boolean;
    whitelabel?: TenantWhitelabel;
    createdAt?: Date;
    updatedAt?: Date;
    accountManager?: {
        email?: string;
        name?: string;
        uid?: string;
    }
}

export interface PlanReference {
    id: string;
    pid: string;
    nameBr: string;
    nameEn: string;
}

export enum TenantStatus {
    ONBOARDING = 'onboarding',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}

export enum TenantLanguage {
    ENGLISH = 'en',
    PORTUGUESE = 'pt-BR',
    SPANISH = 'es',
}

export interface TenantWhitelabel {
    logo: string;
    primaryFont: TenantWhitelabelFont;
    secondaryFont: TenantWhitelabelFont;
    authImage?: string;
    colors: {
        primary: { default: string; contrast: string; shade: string };
        secondary: { default: string; contrast: string; shade: string; tint: string };
        tertiary: { default: string; contrast: string; shade: string; tint: string };
        menu: { default: string; tint: string };
    };
}

export const TENANT_WHITELABEL_FONTS = ['Nunito Sans', 'PT Sans'] as const;
export type TenantWhitelabelFont = typeof TENANT_WHITELABEL_FONTS[number];